// No need for hardcoding, values are all in correct order
const numProDesigns = 26;
const pro = [];

for ( let i = 0; i < numProDesigns; i++ ) {
  const number = 100 + i;
  pro.push( {
    number: `HN${number}`
  });
}

export default pro ;